import React from 'react';
import Icon from '../../../components/AppIcon';

const CapacityIndicator = ({ confirmed, waitlist, capacity }) => {
  const safeCapacity = Number.isFinite(capacity) && capacity > 0 ? capacity : 0;
  const confirmedPercentage = safeCapacity > 0 ? (confirmed / safeCapacity) * 100 : 0;
  const totalRegistered = confirmed + (waitlist || 0);
  const isNearCapacity = safeCapacity > 0 && confirmedPercentage >= 80;
  const isFull = false;

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 lg:p-8 shadow-md">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          참가 현황
        </h3>
        <div className={`
          flex items-center gap-2 px-3 py-1.5 rounded-md
          ${isNearCapacity ? 'bg-warning/10 text-warning' : 'bg-success/10 text-success'}
        `}>
          <Icon 
            name={isNearCapacity ? 'AlertCircle' : 'CheckCircle'} 
            size={16}
          />
          <span className="text-sm font-medium">
            {isNearCapacity ? '마감 임박' : '신청 가능'}
          </span>
        </div>
      </div>
      <div className="space-y-4 md:space-y-6">
        <div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <Icon name="Users" size={18} color="var(--color-primary)" />
              <span className="text-sm md:text-base font-medium text-foreground">
                확정 인원
              </span>
            </div>
            <span className="text-base md:text-lg font-heading font-bold text-primary data-text">
              {safeCapacity > 0 ? `${confirmed} / ${safeCapacity}명` : `${confirmed}명`}
            </span>
          </div>
          <div className="w-full h-3 md:h-4 bg-muted rounded-full overflow-hidden">
            <div 
              className={`h-full transition-athletic ${
                isFull ? 'bg-error' : isNearCapacity ? 'bg-warning' : 'bg-success'
              }`}
              style={{ width: `${Math.min(confirmedPercentage, 100)}%` }}
            />
          </div>
          <p className="text-xs md:text-sm caption text-muted-foreground mt-1">
            {confirmedPercentage?.toFixed(0)}% 차있음
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4 pt-4 border-t border-border">
          <div className="bg-muted/50 rounded-lg p-3 md:p-4">
            <p className="text-xs md:text-sm caption text-muted-foreground mb-1">
              총 신청자
            </p>
            <p className="text-xl md:text-2xl font-heading font-bold text-foreground data-text">
              {totalRegistered}명
            </p>
          </div>
          <div className="bg-muted/50 rounded-lg p-3 md:p-4">
            <p className="text-xs md:text-sm caption text-muted-foreground mb-1">
              남은 자리
            </p>
            <p className="text-xl md:text-2xl font-heading font-bold text-foreground data-text">
              {safeCapacity > 0 ? Math.max(0, safeCapacity - confirmed) : '제한 없음'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapacityIndicator;